import ALL_DETERIORATION_MECHANISMS from '../../../../config/simm/default/deterioration_mechanisms.yml';

export const DEFAULT_RATINGS = [0, 1, 2, 3, 4, 5];

const DETERIORATION_MECHANISMS = { ...ALL_DETERIORATION_MECHANISMS };
delete DETERIORATION_MECHANISMS.default;
export default DETERIORATION_MECHANISMS;
